<div class="container">
    <div class="report-header">
        <div class="row">
            <div class="col-3 d-flex flex-column justify-content-between">
                <img src="assets/img/companies/JTI_Logo.png" width="130">
                <div class="d-flex flex-row">
                    <div class="mr-4">
                        <h3>{{report?.participants}}</h3>
                        <p>participants</p>
                    </div>
                    <div>
                        <h3>{{report?.sessions}}</h3>
                        <p>sessions</p>
                    </div>
                </div>
            </div>
            <div class="col-9">
                <h1>
                    Mental wellness
                    <br>report {{report?.date}}
                </h1>
            </div>
        </div>
    </div>


    <div class="d-flex justify-content-between align-items-center">
        <nav class="nav">

            <button class="nav-item" [ngClass]="{'active': isActive(IntervalName.month)}"
                    (click)="drawData(IntervalName.month)">month
            </button>
            <button class="nav-item" [ngClass]="{'active': isActive(IntervalName.quartal)}"
                    (click)="drawData(IntervalName.quartal)">quarter
            </button>
            <button class="nav-item" [ngClass]="{'active': isActive(IntervalName.year)}"
                    (click)="drawData(IntervalName.year)">year
            </button>
        </nav>
        <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
            <button
                    type="button"
                    class="btn btn-link text-dark me-2"
                    id="dropdownManual"
                    ngbDropdownAnchor
                    (focus)="myDrop.open()"
            >
                <b>Whole company</b>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownManual">
                <button ngbDropdownItem>Action - 1</button>
                <button ngbDropdownItem>Another Action</button>
                <button ngbDropdownItem>Something else is here</button>
            </div>
        </div>
<!--        <p>-->
<!--            <b>Whole company-->
<!--            <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M1 1L5.5 5L10 1" stroke="#10082F" stroke-width="2" stroke-linecap="round"-->
<!--                      stroke-linejoin="round"/>-->
<!--            </svg>-->
<!--        </b></p>-->
    </div>

    <div class="content">
        <h4>{{activeTab?.title}}</h4>
        <p>
            {{activeTab?.subtitle}}
        </p>

        <div class="mb-5 row">
            <div class="col-sm-12 col-md-8">
                <lib-mixed-chart class="d-block mb-5" *ngIf="performanceData"
                                 [chartData]="performanceData"></lib-mixed-chart>
                <p><b>Risk of burnout
                    <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5.5 5L10 1" stroke="#10082F" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                </b></p>

                <lib-burnout-chart class="d-block mt-2" *ngIf="burnoutData" [config]="burnoutData"></lib-burnout-chart>
            </div>
            <div class="col-sm-12 col-md-4">
                <lib-line-chart-filled class=" mb-4 ml-auto mr-auto d-block" *ngIf="anxietyData" [id]="2"
                                       [activeZoneIndex]="3"
                                       [xAxisText]="'Anxiety'"
                                       [data]="anxietyData"></lib-line-chart-filled>
                <lib-line-chart-filled class="mb-4  ml-auto mr-auto d-block" *ngIf="depressionData" [id]="3"
                                       [activeZoneIndex]="3"
                                       [xAxisText]="'Depression'"
                                       [data]="depressionData"></lib-line-chart-filled>

                <div class="table-wrapper mb-4 mt-4">
                    <p><b>Important parameters</b></p>
                    <table class="table">
                        <tr *ngFor="let row of importantParameters">
                            <td class="table-exclaim">
                                <ng-container *ngIf="row?.level === 2"><span [ngClass]="'level_'+ row.level">!</span>
                                </ng-container>
                            </td>
                            <td class="table-value" [ngClass]="'level_'+ row.level">{{row.value}}%</td>
                            <td>{{row.text}}</td>
                        </tr>
                    </table>
                </div>

            </div>
        </div>
        <div class="mb-5">
            <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0">
                <ngb-panel>
                    <ng-template ngbPanelHeader let-opened="opened">
                        <div class="accordion-button custom-header justify-content-between"
                             [class.collapsed]="!opened">
                            <button ngbPanelToggle class="toggle-details" [ngClass]="{'opened': opened}">
                                <b>See details</b>
                                <svg width="14" height="9" viewBox="0 0 14 9" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13 7.90527L7 1.90527L1 7.90527" stroke="#10082F" stroke-width="2"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <ng-container *ngFor="let bar of barValues">
                            <lib-progressbar-stacked [barTitle]="bar.barTitle"
                                                     [values]="bar.values"></lib-progressbar-stacked>
                        </ng-container>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
        <div class="mt-5">
        <app-recommendations *ngIf="recommendations" [results]="recommendations"></app-recommendations>
        </div>
    </div>
</div>
<app-footer></app-footer>
<lib-preloader [loading]="loading"></lib-preloader>
